import { Expose } from "class-transformer";

export class RemoveOnCallsFromCertificationDto {
  @Expose()
  certificationId: string;

  @Expose()
  onCallIds: string[];
}
